import { defineStore } from 'pinia';
import { ContactTimelineFilter, MultiSelectOption } from '@/types';

export const useContactTimelineFilterStore = defineStore('contactTimelineFilter', {
    state: (): ContactTimelineFilter => ({
        callType: null,
        sentiment: null,
    }),

    actions: {
        setCallType(callType: MultiSelectOption<string> | null) {
            this.callType = callType;
        },

        setSentiment(sentiment: MultiSelectOption<string> | null) {
            this.sentiment = sentiment;
        },
    },
});
